module.exports = __webpack_public_path__ + "img/dizhi.a9b8b4a8.png";